export default "__VITE_ASSET__efb16adc__"